module.exports = __webpack_public_path__ + "img/tablet-neck-2_28x214.e902035c.png";